import * as Sentry from "@sentry/react";
import React from 'react'
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom'

import { env } from "./env";

// NOTE: if you receive "ERR_BLOCKED_BY_CLIENT" error perhaps some extension blocks fetch request(f.e. uBlock)
Sentry.init({
	dsn: env.SENTRY_DSN,
	debug: env.SENTRY_DEBUG,
	environment: env.SENTRY_ENV,
	tracePropagationTargets: ['localhost', env.BASE_URL],
	enabled: env.SENTRY_ENV !== 'local',
	integrations: [
		new Sentry.BrowserTracing({
			routingInstrumentation: Sentry.reactRouterV6Instrumentation(
				React.useEffect,
				useLocation,
				useNavigationType,
				createRoutesFromChildren,
				matchRoutes
			),
		}),
		// new Sentry.Replay()
	],
	tracesSampleRate: 1.0,
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,
});

export const sentryReduxEnhancer = Sentry.createReduxEnhancer({
	attachReduxState: env.SENTRY_WITH_REDUX,
});
